import React from "react";
import { Clock, Tag, CheckCircle2, PhoneCall } from "lucide-react";
import { IMAGES, PHONES, toTel } from "../../mock";
import ProviderCarousel from "./ProviderCarousel";

const IconItem = ({ icon: Icon, children }) => (
  <div className="flex items-center gap-2">
    <Icon className="h-[18px] w-[18px] shrink-0" style={{ color: "var(--me-blue)" }} strokeWidth={2} aria-hidden="true" />
    <span className="text-[13.5px] sm:text-[15px]" style={{ color: "var(--me-heading)" }}>{children}</span>
  </div>
);

const HeroSection = () => {
  return (
    <section className="relative overflow-hidden">
      <div className="max-w-[960px] mx-auto px-5 pt-5 pb-9 md:pt-9 md:pb-14 text-center me-fade-up">
        <h1
          className="text-[23px] leading-[1.15] sm:text-[32px] md:text-[42px] font-extrabold tracking-tight"
          style={{ color: "var(--me-heading)" }}
        >
          SOUSCRIRE OU GÉRER VOTRE CONTRAT D’ÉNERGIE
        </h1>

        <div className="mt-5 md:mt-7 flex justify-center">
          <img
            src={IMAGES.partners}
            alt="Fournisseurs partenaires : EDF, Engie, TotalEnergies, ENI"
            width={640}
            height={109}
            loading="eager"
            fetchPriority="high"
            className="h-10 sm:h-12 md:h-14 w-auto object-contain"
          />
        </div>

        <div className="mt-3 flex justify-center">
          <img
            src={IMAGES.enedisHeader}
            alt="Enedis"
            width={320}
            height={68}
            loading="eager"
            className="h-4 md:h-5 w-auto object-contain"
          />
        </div>

        <div className="mt-5 md:mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2.5">
          <IconItem icon={Clock}>Service Client 8h-21h</IconItem>
          <IconItem icon={Tag}>Nouveaux tarifs</IconItem>
          <IconItem icon={CheckCircle2}>Ouverture compteur</IconItem>
        </div>

        <div className="mt-5 md:mt-6 flex flex-col items-center gap-3">
          <a
            href={toTel(PHONES.main)}
            data-testid="hero-cta"
            aria-label="Parler à un conseiller, appel gratuit 7j/7"
            className="flex flex-col items-center rounded-2xl px-12 py-3 text-white shadow-[0_10px_24px_rgba(38,38,221,0.28)] transition-colors"
            style={{ backgroundColor: "var(--me-blue)" }}
            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "var(--me-blue-hover)")}
            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "var(--me-blue)")}
          >
            <span className="text-[19px] font-bold tracking-wide">Parler à un conseiller</span>
            <span className="text-[11.5px] opacity-90">Appel Gratuit 7j/7</span>
          </a>

          <a
            href={toTel(PHONES.urgences)}
            data-testid="hero-urgences"
            aria-label={`Urgences et dépannages, appeler le ${PHONES.urgences}`}
            className="flex items-center gap-2 rounded-full px-7 py-2.5 font-semibold text-[13px] tracking-wide transition-colors"
            style={{ backgroundColor: "var(--me-green)", color: "var(--me-navy)" }}
            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "var(--me-green-hover)")}
            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "var(--me-green)")}
          >
            <PhoneCall className="h-4 w-4" aria-hidden="true" />
            URGENCES ET DÉPANNAGES
          </a>
        </div>

        <p className="mt-5 text-[13.5px] sm:text-[15px] max-w-xl mx-auto" style={{ color: "var(--me-text)" }}>
          L'équipe de meilleurelec.fr vous aide à comparer les offres de fournisseurs avec ses
          offres partenaires.
        </p>
      </div>

      <div className="max-w-[1140px] mx-auto px-6 pb-12">
        <ProviderCarousel />
      </div>
    </section>
  );
};

export default HeroSection;
